import tenantUtils from '@utils';
import { t } from 'i18next';

export const cartDataMapper = (response, meta, arg) => {
  if (arg?.orderId) {
    const { id, status, details } = response?.data?.orders?.items[0];
    if (status === 'completed') {
      return { error: `Order is in ${status} state` };
    }
    return {
      cartProducts: tenantUtils.cartProductList(
        details.map((e) => ({
          id: e.id,
          product_id: e.product.id,
          product: { id: e.product.id, title: e.product.name, slug: e.product_slug, price: e.unit_price },
          quantity: e.quantity,
          price: e.unit_price,
          source: 'profolio',
        })),
      ),
      cartId: id,
      source: 'profolio',
    };
  } else if (!response?.cart?.cart_details?.length) {
    const {
      id,
      source,
      amount,
      total_amount,
      total_credits,
      user_available_credits,
      listing_id,
      purchased_full_credits,
      discount,
      available_channels = [],
    } = response?.cart;
    return {
      cartId: id,
      source: source,
      total: amount,
      oldTotal: total_amount,
      totalCredits: total_credits,
      availableCredits: user_available_credits,
      listing_id,
      purchasedFullCredits: purchased_full_credits,
      cartProducts: [{ title: t('Credits'), quantity: total_credits, price: total_amount }],
      discount: discount,
      available_channels,
    };
  } else {
    const {
      id,
      source,
      cart_details,
      amount,
      total_amount,
      total_credits,
      user_available_credits,
      listing_id,
      purchased_full_credits,
      refundable_amount,
      discount,
      available_channels = [],
    } = response?.cart;
    return {
      cartProducts: tenantUtils.cartProductList(cart_details),
      cartId: id,
      source: source,
      total: amount,
      adjustment_amount: refundable_amount,
      discount: discount,
      oldTotal: total_amount,
      totalCredits: total_credits,
      availableCredits: user_available_credits,
      listing_id,
      purchasedFullCredits: purchased_full_credits,
      available_channels,
    };
  }
};

export default { cartDataMapper };
